import { render } from "./candid-mode-form.vue?vue&type=template&id=78f19110&scoped=true&lang=true"
import script from "./candid-mode-form.vue?vue&type=script&lang=js"
export * from "./candid-mode-form.vue?vue&type=script&lang=js"

import "./candid-mode-form.vue?vue&type=style&index=0&id=78f19110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f19110"]])

export default __exports__